import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_PREFERENCES_ARE_UPDATED:
        "Godt jobbet! Dine matpreferanser er oppdatert.",
      YOUR_PREFERENCES_ARE_UPDATED_SUBTITLE:
        "Har du allerede valgt middager selv, vil disse ikke bli påvirket. Du kan se endringene dine på Min konto.",
      SHOW_MY_MENU: "Flott, vis menyen min!",
      CHANGE_YOUR_PREFERENCES: "Endre dine preferanser",
      WE_COUDNT_SAVE_YOUR_CHANGES:
        "Beklager, vi kunne ikke lagre endringene dine",
      SOMETHING_WENT_WRONG:
        "Noe gikk galt, og vi jobber allerede med å løse problemene. Prøv igjen snart.",
      BACK_TO_MY_MENU: "Tilbake til menyen min",
      NEED_HELP: "Trenger du hjelp?",
      SOMETHING_WENT_WRONG_NOTIFICATION: "Endringene lagres ikke",
      PORTIONS: "porsjoner",
      MEALS: "middager",
      YOUR_CHOICE: "Dine valg:",
    },
    se: {
      YOUR_PREFERENCES_ARE_UPDATED:
        "Bra jobbat! Dina matpreferenser är uppdaterade.",
      YOUR_PREFERENCES_ARE_UPDATED_SUBTITLE:
        "Har du redan valt middagar själv kommer dessa inte att påverkas. Du kan se dina ändringar på Mitt konto.",
      SHOW_MY_MENU: "Härligt, visa min meny!",
      CHANGE_YOUR_PREFERENCES: "Ändra dina matpreferenser",
      WE_COUDNT_SAVE_YOUR_CHANGES:
        "Ajdå, vi kunde tyvärr inte spara dina ändringar",
      SOMETHING_WENT_WRONG:
        "Något gick fel och vi jobbar redan på att lösa problemet. Vänligen försök snart igen.",
      BACK_TO_MY_MENU: "Tillbaka till min meny",
      NEED_HELP: "Behöver du hjälp?",
      SOMETHING_WENT_WRONG_NOTIFICATION: "Ändringarna sparades inte",
      PORTIONS: "portioner",
      MEALS: "middagar",
      YOUR_CHOICE: "Dina val:",
    },
    dk: {
      YOUR_PREFERENCES_ARE_UPDATED: "Din måltidskasse er opdateret.",
      YOUR_PREFERENCES_ARE_UPDATED_SUBTITLE:
        "Du kan se dine registrerede ændringer under 'Mit abonnement'. Har du allerede valgt retter til en eller flere af dine kommende leveringer, vil disse ikke blive påvirket af denne ændring.",
      SHOW_MY_MENU: "Fantastisk, vis min menu!",
      CHANGE_YOUR_PREFERENCES: "Skift dine præferencer",
      WE_COUDNT_SAVE_YOUR_CHANGES:
        "Beklager, vi kunne ikke gemme dine ændringer",
      SOMETHING_WENT_WRONG:
        "Noget gik galt, og vi arbejder allerede på at løse problemerne. Prøv igen senere.",
      BACK_TO_MY_MENU: "Tilbage til min menu",
      NEED_HELP: "Brug for hjælp?",
      SOMETHING_WENT_WRONG_NOTIFICATION: "Ændringerne blev ikke gemt",
      PORTIONS: "portioner",
      MEALS: "retter",
      YOUR_CHOICE: "Dine valg:",
    },
  } as const
)[language];
